import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { ApiMutation } from '../../../../common/model/api.mutation';

export interface DeleteTaskParams {
	readonly id: string;
}

@Injectable({ providedIn: 'root' })
export class DeleteTaskApiMutation extends ApiMutation<
	string,
	DeleteTaskParams
> {
	client = 'iam';
	document = gql`
		mutation DeleteTask($id: UUID!) {
			deleteTask(id: $id)
		}
	`;
	method = 'deleteTask';
}
